export default __webpack_public_path__ + "static/media/icon_skill_add_2.b02ea824.png";